import { render, staticRenderFns } from "./AceitarTermos.vue?vue&type=template&id=5fbd57c7&"
import script from "./AceitarTermos.vue?vue&type=script&lang=js&"
export * from "./AceitarTermos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports